import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { EmojiTrendingPreview } from '@root/entities/premium/ui/emoji-trending-preview'
import { useAssetsUrlBuilder } from '@root/shared'

import { EmojiPreviewBox } from './emoji-preview-box'

import type { CurrencyModel } from '@root/entities/currency'

type Props = {
  emojiId: string | undefined
  currency: CurrencyModel
  onUploadClick: () => void
}

export const PremiumImageDrawerPreview: React.FC<Props> = ({
  currency,
  emojiId,
  onUploadClick,
}) => {
  const { t } = useTranslation()

  const { customEmojiPngUrl } = useAssetsUrlBuilder()

  return (
    <Root>
      <SubTitle>
        {t('premium.image-upload.size', { size: '256x256' })}{' '}
      </SubTitle>
      <Content>
        <EmojiPreviewBox title={currency.title} emojiId={emojiId} />
        <ButtonEdit
          type="button"
          variant="secondary"
          size="s"
          onClick={onUploadClick}
        >
          {emojiId
            ? t('premium.update-emoji.change-image')
            : t('premium.update-emoji.choose-image')}
        </ButtonEdit>
      </Content>
      <Caption>{t('premium.update-emoji.preview')}</Caption>

      <EmojiTrendingPreview
        previewUrl={emojiId ? customEmojiPngUrl(emojiId) : undefined}
        currency={currency}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  padding: 0 16px;
`

const Content = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;

  align-content: center;

  gap: 20px;
  height: 280px;
`

const SubTitle = styled.p`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  margin-top: 10px;
  text-align: center;
`

const Caption = styled.p`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 16px;
`

const ButtonEdit = styled(Button)``
